import {
  AVAILABLE,
  getExperimentVariant,
  PACKAGES_CHECKOUT_OPTIMIZATIONS_V1,
} from "../../../../context/experiments";
import { PackagesMachineContext } from "../types";

export const PackagesCommonGuards = {
  isMobile: (ctx: PackagesMachineContext) => ctx.platform === "mobile",
  isDesktop: (ctx: PackagesMachineContext) => ctx.platform === "desktop",
  hasFinalizePackageResponse: (ctx: PackagesMachineContext) =>
    !!ctx.finalizePackageResponse,
  isPackageCheckoutOptimizationsV1Experiment: (ctx: PackagesMachineContext) =>
    getExperimentVariant(
      ctx.experiments,
      PACKAGES_CHECKOUT_OPTIMIZATIONS_V1
    ) === AVAILABLE,
};
